import { useEffect, useRef, useState } from "react";
import * as apiHelper from "../../../Services/ApiHelper";
import * as toast from "../../../Wrapper/toast/toast";
import { changeDateFormatForServer } from "../../../Utils/dateUtils";
import { useNavigate } from "react-router-dom";
import { getLocalData } from "../../../Services/common";
import { CONFIG } from "../../../Constants/storageConstant";
import TrackPatientUI from "./TrackPatientUI";

const TrackPatient = () => {
  const navigate = useNavigate();
  const [startRange, setStartRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [endRange, setEndRange] = useState({ startDate: null, endDate: null });
  const [activeStatus, setActiveStatus] = useState("active");
  const [patientsList, setPatientsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedGender, setSelectedGender] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState([]);
  const [ageRange, setAgeRange] = useState({ from: "", to: "" });
  const [allDiagnosis, setAllDiagnosis] = useState([]);

  const onPageChange = (page) => {
    getPatientsList(page);
  };

  const getPatientsList = async (page = 1) => {
    setLoading(true);

    const filters = {
      page,
      activeStatus,
      limit: 10,
      gender: selectedGender,
      city: selectedCity,
      age_from: ageRange.from,
      age_to: ageRange.to,
      diagnosis: selectedDiagnosis,
      doctor: selectedDoctor,
      medicines: selectedMedicines,
      services: selectedServices,
      start_from_date: changeDateFormatForServer(startRange.startDate),
      start_to_date: changeDateFormatForServer(startRange.endDate),
      end_from_date: changeDateFormatForServer(endRange.startDate),
      end_to_date: changeDateFormatForServer(endRange.endDate),
    };

    try {
      apiHelper.getPatientsTrackReport(filters).then((response) => {
        setLoading(false);
        if (response?.isSuccess) {
          setPatientsList(response?.data);
        } else {
          toast.warn(response?.message);
        }
      });
    } catch (err) {
      toast.error("Something went wrong");
    }
  };
  const getDiagnosisList = (page = 1) => {
    const query = `?page=${page}&limit=1000`;

    apiHelper
      .getDiagnosisList(query)
      .then((response) => {
        if (response?.isSuccess) {
          setAllDiagnosis(response?.data?.data);
        } else {
          toast.warn(response?.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => setLoading(false));
  };

  const openDetailsPage = (id) => navigate(`/patient-visit/${id}`);
  useEffect(() => {
    getDiagnosisList();
  }, []);
  return (
    <TrackPatientUI
      startRange={startRange}
      endRange={endRange}
      setStartRange={setStartRange}
      setEndRange={setEndRange}
      activeStatus={activeStatus}
      setActiveStatus={setActiveStatus}
      openDetailsPage={openDetailsPage}
      patientsList={patientsList}
      loading={loading}
      getPatientsList={getPatientsList}
      selectedMedicines={selectedMedicines}
      setSelectedMedicines={setSelectedMedicines}
      selectedServices={selectedServices}
      setSelectedServices={setSelectedServices}
      selectedGender={selectedGender}
      setSelectedGender={setSelectedGender}
      selectedCity={selectedCity}
      setSelectedCity={setSelectedCity}
      selectedDiagnosis={selectedDiagnosis}
      setSelectedDiagnosis={setSelectedDiagnosis}
      selectedDoctor={selectedDoctor}
      setSelectedDoctor={setSelectedDoctor}
      ageRange={ageRange}
      setAgeRange={setAgeRange}
      allDiagnosis={allDiagnosis}
      onPageChange={onPageChange}
    />
  );
};

export default TrackPatient;
